import { Injectable, EventEmitter } from '@angular/core';
import { quarters } from '../constants/constants';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  getSearchedData(data: any[], filterText: string): any[] {
    if (filterText?.trim()) {
      const lowerCaseFilterText = filterText?.trim()?.toLowerCase();
      return data?.filter((each: any) =>
        Object.keys(each)?.some((eachKey) => {
          const value = each[eachKey]?.toString()?.toLowerCase() ?? '';
          if (!isNaN(Number(filterText)) && filterText?.trim() === value) {
            return true;
          }
          return value.includes(lowerCaseFilterText);
        })
      );
    } else {
      return [...data];
    }
  }

  getFilteredValue(event: KeyboardEvent) {
    return event.target instanceof HTMLInputElement
      ? event.target?.value?.trim()
      : '';
  }

  getTotalCandidatesCount(
    data: any[],
    selectedTab: any,
    candidatesCountChange: EventEmitter<number>
  ): number {
    const total = data?.length;
    if (selectedTab) {
      selectedTab.badgeContent = total?.toString();
    }
    candidatesCountChange.emit(total);
    return total;
  }
  getContPositions(data: any[], selectedTab: any): number {
    const positionCount = (data ?? []).reduce(
      (total, position) => total + (position?.numberOfPositions ?? 0),
      0
    );
    if (selectedTab) {
      selectedTab.badgeContent = positionCount.toString();
    }
    return positionCount;
  }

    getCurrentQuarterAndYear(): { quarter: string | number; year: number } {
      const currentDate = new Date();
      const month = currentDate.getMonth();
      const year = currentDate.getFullYear();
      const quarter = quarters[Math.floor(month / 3)];
      return { quarter, year };
    }
}
